import { format, isValid } from "date-fns";

export const formateUploadDate = (dateString) => {
  let date = new Date(Date.parse(dateString));

  return (
      date.toLocaleString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
      }) +
      ", " +
      date.toDateString()
  );
};

export const genderOptions = ["Female", "Male", "Other"];

export function formatDateToInputFormat(dateString) {
  if (!dateString) {
      return "";
  }

  const parts = dateString.split("/");

  if (parts.length < 3) {
      // console.error(`Invalid date format: ${dateString}`);

      // return dateString;
      return parts;
  }

  const [month, day, year] = parts;

  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
}

export const formatDateToOutputFormat = (dateString) => {
  if (dateString && isValid(new Date(dateString))) {
      const date = new Date(dateString);
      const utcDate = new Date(
          date.getUTCFullYear(),
          date.getUTCMonth(),
          date.getUTCDate(),
      );
      return format(utcDate, "MM/dd/yyyy");
  } else {
      return "";
  }
};